import { CHANGED, LOADING, FAILED, MESSAGE, FETCHED } from './constants';

export const initialState = {
  isLoading: false,
  message: '',
  success: false,
  code: 200,
  data: {},
  key: '',
};

export default function reducer(state = initialState, action) {
  const { type, isLoading, message, success, code, data, key } = action;

  switch (type) {
    case CHANGED:
      return {
        ...state,
        isLoading: false,
        key,
        message,
        success,
      };
    case FAILED:
      return {
        ...state,
        message,
        key,
        code,
      };

    case LOADING:
      return {
        ...state,
        isLoading,
      };
    case MESSAGE:
      return {
        ...state,
        code,
        key,
        message,
      };
    case FETCHED:
      return {
        ...state,
        message,
        code,
        data,
        key,
      };
    default:
      return state;
  }
}
